import React from 'react';

const Instructions = ({ region, title, helperText, panelWidth }) => {
	const baseHeight = region === 'inbound' ? 80 : 40;
	const dataQaSubText = title ? title.toLowerCase().split(' ')[0] : 'panel';

	// Only need to do this when panel shrinks below 650, which is when length of texts pushes beyond set height.
	// For each 55px below the threshold, add the lineheight value to base height (minimum of one)
	const calculatedHeight =
		(Math.floor((650 - panelWidth) / 55) + 1) * 20 + baseHeight;
	const classNames =
		panelWidth > 650 ? 'helper-text' : `helper-text height-${calculatedHeight}`;

	return (
		<div
			className={`common-inbound-details-instructions ${region}`}
			data-qa={`common-inbound-details-instructions-${dataQaSubText}`}
			{...{ dataqa: `common-inbound-details-instructions-${dataQaSubText}` }}
		>
			<p className="title">{title}</p>
			<p className={classNames}>{helperText}</p>
		</div>
	);
};

export default Instructions;
